__turbopack_context__.v({
  "wrapper": "markdown-module-scss-module__lBpR8q__wrapper",
});
